import React from "react";
import { ClipLoader } from "react-spinners";
import { Card, CardBody, CardHeader, CardTitle, Col, Row } from "reactstrap";

// Casca dos cards da aba "Despacho" (PO1-3494): mesmo visual dos gráficos da
// Torre (card-chart com h4 + CardTitle, loader e "Nenhum dado para
// apresentar!"), para os 5 blocos não repetirem o esqueleto.

// Paleta dos gráficos de despacho (Black Dashboard, como os demais da Torre).
export const CORES = {
  emitidas: "#2dce89",
  falhas: "#fd5d93",
  lotes: "#1d8cf8",
  neutro: "#ff8d72",
};

export default function CartaoGrafico({ titulo, subtitulo, carregando = false, erro = null, vazio = false, textoVazio = "Nenhum dado para apresentar!", textoErro = "Não conseguimos carregar o resumo de despacho.", children }) {
  return (
    <Card style={{ boxShadow: "0px 1px 20px 0px rgb(0, 0, 0)" }} className="card-chart">
      <CardHeader>
        <Row style={{ alignItems: "center" }}>
          <Col>
            <h4>{titulo}</h4>
          </Col>
        </Row>
        {subtitulo ? <CardTitle>{subtitulo}</CardTitle> : null}
      </CardHeader>
      <CardBody>
        {carregando ? (
          <div style={{ textAlign: "center" }}>
            <ClipLoader sizeUnit="px" size={60} color="#1d8cf8" loading />
            <br />
            <h4 className="text-info" style={{ textAlign: "center" }}>
              Carregando ...
            </h4>
          </div>
        ) : null}
        {!carregando && erro ? (
          <div style={{ textAlign: "center" }}>
            <h5>{textoErro}</h5>
          </div>
        ) : null}
        {!carregando && !erro && vazio ? (
          <div style={{ textAlign: "center" }}>
            <h5>{textoVazio}</h5>
          </div>
        ) : null}
        {!carregando && !erro && !vazio ? children : null}
      </CardBody>
    </Card>
  );
}
